export function getIPSearches ({ state, commit }, { search, datefrom, dateto, noorders, page = 1 }) {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/v1/searchips', { params: { search, datefrom, dateto, noorders, page: page } })
      .then((response) => {
        if (response.data.searches) {
          commit('setIPSearches', response.data.searches)
        }

        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function getCkeysOrders ({ state, commit }, { ckeys, ip }) {
  return new Promise((resolve, reject) => {
    if (ckeys) {
      axiosInstance.post('/v1/searches/ip_ck_orders', { ckeys, ip })
        .then((response) => {
          if (response.data.ckeys) {
            commit('setCkeysOrders', { ip, ckeys: response.data.ckeys })
          }
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('Lipsa chei client'))
    }
  })
}

export function getIPOrders ({ state, commit }, { ip }) {
  return new Promise((resolve, reject) => {
    if (ip && ips.length > 0) {
      axiosInstance.post('/v1/searches/ip_orders', { ips: ip, lastmonth: 1 })
        .then((response) => {
          if (response.data.ips) {
            commit('setIPOrders', { ip: response.data.ips })
          }
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('Lipsa ip'))
    }
  })
}

export function getIPsOrders ({ state, commit }, ips) {
  return new Promise((resolve, reject) => {
    if (ips && ips.length > 0) {
      axiosInstance.post('/v1/searches/ip_orders', { ips, lastmonth: 1 })
        .then((response) => {
          if (response.data.ips) {
            commit('setIPsOrders', response.data.ips)
          }
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('Lipsa ip-uri'))
    }
  })
}
